import { HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Endpoints } from '../../definitions/endpoints';
import { Routes } from '../../definitions/routes';

export function setupDinamico(): void {
  const id = 'dinamico';

  void HttpService.get<{ title: string }>(Endpoints.GET.MENU_DINAMICO)
    .then(({ body }) => {
      if (body) {
        try {
          applicationModuleRegistry.get(id);
        } catch {
          applicationModuleRegistry.register({
            entry: id,
            id,
            name: body.title,
            route: Routes.DINAMICO,
            order: 12,
            closeable: true,
          });
        }
      }
    });
}
